import React from 'react';
import { Badge, Image } from '@blend-ed/blendx-ui';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import placeholder from './placeholder.jpg';
import placeholderDark from './placeholder-dark.png';

const BaseCard = ({
  title,
  image,
  className,
  onClick,
  renderFooter,
  renderInfoPanel,
  badgeVariant,
  badgeText,
  disabled,
  startDate,
  extraBadgeText,
}) => {
  const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';

  return (
    <div
      className={classNames("course-card", className, { 'course-card--disabled': disabled })}
      onClick={disabled ? null : onClick}
    >
      <Image
        src={image}
        alt={title}
        className="course-card__image"
        onError={(e) => { e.target.src = isDarkMode ? placeholderDark : placeholder; }}
      />
      <div className="course-card__body">
        <div className="course-card__head">
          <div className="course-card__badges">
            <Badge
              variant={badgeVariant}
              className="course-card__badge"
            >
              {badgeText}
            </Badge>
            {extraBadgeText && (
              <Badge
                variant={extraBadgeText.variant}
                className="course-card__badge"
              >
                {extraBadgeText.text}
              </Badge>
            )}
          </div>
          <div className="course-card__title text-truncate-2">
            {title}
          </div>
          {renderInfoPanel?.()}
        </div>
        <div className="course-card__footer">
          {renderFooter?.()}
        </div>
      </div>
    </div>
  );
};

BaseCard.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  estimatedTime: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  renderFooter: PropTypes.func,
  renderInfoPanel: PropTypes.func,
  badgeVariant: PropTypes.string,
  badgeText: PropTypes.string,
  disabled: PropTypes.bool,
  extraBadgeText: PropTypes.string,
};

BaseCard.defaultProps = {
  estimatedTime: null,
  className: null,
  onClick: () => { },
  renderFooter: null,
  renderInfoPanel: null,
  badgeVariant: null,
  badgeText: null,
  disabled: false,
  extraBadgeText: null,
};

export default BaseCard; 